export function apiKeyFor(env, api) {
  // Could be used for external APIs / APIs with specific keys
  const apis = {
    bv: {},
    kpf: {
      dev: 'iCPzE7NM25XIzdu0ZjIGGWD3TDFoISAB',
      prod: 'x5w9jA8tWVGcqRhujrHTvjRwQfH8MkFc',
      'prod-beta': 'x5w9jA8tWVGcqRhujrHTvjRwQfH8MkFc',
      stage: 'iCPzE7NM25XIzdu0ZjIGGWD3TDFoISAB'
    },
    fbt: {
      dev: '',
      prod: '',
      'prod-beta': '',
      stage: ''
    },
    ratings: {
    },
    searchNav: {
      dev: '',
      prod: '',
      'prod-beta': '',
      stage: ''
    }
  };
  return apis[api] && apis[api][env];
}

export function environmentKey(environment) {
  let env = environment ? environment.toLowerCase() : '';
  if (['dev', 'prod', 'prod-beta', 'stage'].indexOf(env) === -1) {
    console.warn('Invalid environment.');
    env = 'prod';
  }
  const keys = {
    dev: 'iCPzE7NM25XIzdu0ZjIGGWD3TDFoISAB',
    prod: 'x5w9jA8tWVGcqRhujrHTvjRwQfH8MkFc',
    'prod-beta': 'x5w9jA8tWVGcqRhujrHTvjRwQfH8MkFc',
    stage: 'iCPzE7NM25XIzdu0ZjIGGWD3TDFoISAB',
  };
  return keys[env];
}
